export const removeSpaces = str => {
  if (!str) return '';
  return str?.replace(/\s+/g, '');
};

export const isValidHex = hex => {
  if (!hex) return false;
  const hexPattern = /^#([0-9A-F]{3}|[0-9A-F]{6})$/i;
  return hexPattern?.test(hex);
};

export const handleAndShowApiException = (error, toast) => {
  toast?.current?.show({
    severity: 'error',
    summary:
      error &&
      typeof error === 'object' &&
      error !== null &&
      'response' in error &&
      typeof error.response?.data?.message === 'string'
        ? error.response?.data?.message
        : 'Something went wrong',
    life: 2000,
  });
};

export const removeTrimExtraSpaces = inputString => {
  if (!inputString) return '';
  let cleanedString = inputString.replace(/\s+/g, ' ');
  cleanedString = cleanedString.trim();
  return cleanedString;
};

export const isString = value => {
  return typeof value === 'string';
};

export const stripEnvValue = value =>
  value
    ? String(value)
        .trim()
        .replace(/^['"]|['"]$/g, '')
    : '';
